<!-- Sidebar -->
<app-vessel-sidebar />

<!-- Info Panel: fixed overlay, contributes zero width to this flex row -->
<router-outlet></router-outlet>
